import { Stack, Typography } from "@mui/material"
import React from "react"
import { ComboCaseAttribute } from "./ComboCaseAttribute"
import { SingleCaseAgreementAttribute } from "./SingleCaseAgreementAttribute"
import { ZeroReimbursementAttribute } from "./ZeroReimbursementAttribute"
import { IsEscalatedAttribute } from "./IsEscalatedAttribute"
import { IsVobRequestAttribute } from "./IsVobRequestAttribute"
import { IsCheckOonNotesAttribute } from "./IsCheckOonNotesAttribute"
import { PreQuoteCompleteAttribute } from "./PreQuoteCompleteAttribute"

function BenefitsAttributes(){
    return <React.Fragment>
        <Typography sx={{borderBottom:'2px solid gray'}} variant='h6' className="psn-green">Benefits Attributes</Typography>
        <Stack gap={3} direction='row' marginTop='10px' marginBottom='20px' marginRight='15px' justifyContent='flex-start' flexWrap='wrap'>
            <ComboCaseAttribute/>
            <SingleCaseAgreementAttribute/>
            <ZeroReimbursementAttribute/>
        </Stack>
        <Stack gap={3} direction='row' marginBottom='20px' marginRight='15px' justifyContent='flex-start'>
            <IsEscalatedAttribute/>
            <IsVobRequestAttribute/>
            <IsCheckOonNotesAttribute/>
            <PreQuoteCompleteAttribute/>
        </Stack>
    </React.Fragment>
}
export{BenefitsAttributes}